import { IncludedSeatsDisplay } from '../../../components/merch-card/seats-display/IncludedSeatsDisplay';
import { useCurrencyCodeUnitToDisplay, useDisplayedCurrencyCode } from '../../../hooks/useCurrencyDetails';
import { useIncludedCommerceSeats, useIncludedCoreSeats, useIncludedSalesSeats, useIncludedServiceSeats } from '../../../hooks/useProductDetails';
import { useSeatsDisplay } from './useSeatsDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
export const IncludedSeatsDisplayContainer = ({
  productApiName
}) => {
  // Currency Props
  const currencyCode = useDisplayedCurrencyCode();
  const currencyCodeUnit = useCurrencyCodeUnitToDisplay();

  // Seat Props
  const includedCoreSeats = useIncludedCoreSeats({
    productApiName
  });
  const includedSalesSeats = useIncludedSalesSeats({
    productApiName
  });
  const includedServiceSeats = useIncludedServiceSeats({
    productApiName
  });
  const includedCommerceSeats = useIncludedCommerceSeats({
    productApiName
  });
  const {
    showIncludedSeats,
    showAdditionalSeatsPriceSubtext,
    additionalCoreSeatsPrice
  } = useSeatsDisplay();
  return /*#__PURE__*/_jsx(IncludedSeatsDisplay, {
    includedCoreSeats: includedCoreSeats !== null && includedCoreSeats !== void 0 ? includedCoreSeats : 0,
    includedSalesSeats: includedSalesSeats !== null && includedSalesSeats !== void 0 ? includedSalesSeats : 0,
    includedServiceSeats: includedServiceSeats !== null && includedServiceSeats !== void 0 ? includedServiceSeats : 0,
    includedCommerceSeats: includedCommerceSeats !== null && includedCommerceSeats !== void 0 ? includedCommerceSeats : 0,
    showIncludedSeats: showIncludedSeats,
    showAdditionalSeatsPriceSubtext: showAdditionalSeatsPriceSubtext,
    additionalCoreSeatsPrice: additionalCoreSeatsPrice,
    currencyCode: currencyCode,
    currencyCodeUnit: currencyCodeUnit
  });
};